var Vendd = (function (Vendd) {
    'use strict';

    Vendd.User = (function (User) {

        var pending = false;

        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionState, Vendd.User, function (envelope) {
            if (pending === true) {
                return false; //get session cannot run twice
            };

            function onSuccess(response) {
                Vendd.User.SessionState = response;
                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionStateSuccess(Vendd.User.SessionState));
            };

            function onFailure(response) {
                Vendd.User.SessionState = { IsNewSession: true };
                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionStateSuccess(Vendd.User.SessionState));
            };

            var options = {
                method: 'POST',
                url: 'api/Tools/GetSessionStatus',
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            pending = true;

            Vendd.Service.call(options);

            return true;
        });

        return User;

    })(Vendd.User || {});

    return Vendd;

})(Vendd || {});